import { IPromise } from 'angular';

import { FlowDetailInfo } from '../models/FlowInfo';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { DataSources } from '../../content/resources/Datasources';
import { IModalScope, ModalService, ModalType } from './ModalService';

interface FlowPublishSuccessDialogScope extends IModalScope {
  flowMessage: string;
  datasources?: IDataSourceBase[];
}

export class PublishFlowAction {

  public static $inject: any = [
    '$translate',
    '$rootScope',
    'ModalService',
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private $rootScope: ng.IRootScopeService,
    private ModalService: ModalService,
  ) {
  }

  public handlePublishedFlow(flow: FlowDetailInfo, publishedDatasourceUrlNames: string[]): IPromise<any> {
    const successDialogScope: FlowPublishSuccessDialogScope = <FlowPublishSuccessDialogScope>this.$rootScope.$new();

    successDialogScope.flowMessage = flow.name;

    if(publishedDatasourceUrlNames.length > 0) {
      DataSources.getPublishedByUrlNames(publishedDatasourceUrlNames)
    .then((result => {
      successDialogScope.datasources = result.items;
      return this.openDialog(successDialogScope);
    }));
    } else {
      return this.openDialog(successDialogScope);
    }
  }

  private openDialog(successDialogScope: FlowPublishSuccessDialogScope) {
    const modalInstance = this.ModalService.open({
      size: '400px',
      type: ModalType.Unification,
      title: this.$translate.instant('publishDatasourceSuccessDialogTitleComplete'),
      templateUrl: 'flowPublishSuccessDialog.html',
      scope: successDialogScope,
      tbTestId: 'publish-flow-success-modal',
    });
    return modalInstance.result.finally(() => successDialogScope.$destroy());
  }
}

Module.instance().service('PublishFlowAction', PublishFlowAction);
